import React from 'react'
import { Popover as HeadlessPopover, Transition} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Fragment } from 'react'

export function Popover({children, label}) {
    return (
      <div className="">
        <HeadlessPopover className="relative">
          {({ open }) => (
            <>
              <HeadlessPopover.Button
                className={`
                  ${open ? '' : 'text-opacity-90'}
                  group flex w-full items-center text-gray-600 hover:text-gray-800 rounded-md hover:bg-gray-200 bg-gray-100 px-3 py-2 text-base font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
              >
                <div className='items-center w-full md:flex'>
                  <span className='ml-1 text-sm'>{label}</span>
                </div>


                <ChevronDownIcon
                  className={`${open ? '' : ''}
                  ml-2 h-5 w-5 transition duration-150 ease-in-out group-hover:text-opacity-80`}
                  aria-hidden="true"
                  />
              </HeadlessPopover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <HeadlessPopover.Panel className="absolute z-10 w-full min-w-[18rem] pb-10 mt-3 transform -translate-x-1/2 lg:w-72 left-1/2">
                  <div className="overflow-hidden rounded-md shadow-lg ring-1 ring-black ring-opacity-5 ">
                      <div className="relative p-5 bg-white ">
                          {children}
                      </div>
                  </div>
                </HeadlessPopover.Panel>
              </Transition>
            </>
          )}
        </HeadlessPopover>
      </div>
    )
  }
